import Symbol from './Symbol';
import {Plugins} from '@packages/systems/wfdl';

export const plugin = Plugins.PrivilegedPlugin({atoms: {Symbol}});
